module.exports = __webpack_public_path__ + "static/media/amazon_seller_central_02.74145da3.jpg";